import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { LinkButton } from '~/lib/ui/button'
import { Card } from '~/components/_atoms'
import YnsIcon from '../../icons/YnsIcon'

export function UpcomingEventsCard({ className }) {
  const { t } = useTranslation()
  const coachChatImage =
    'https://www-yns-com.s3.amazonaws.com/images/dashboard/upcoming_events.png'

  return (
    <Card
      className={className}
      color="secondary"
      title={t('upcoming_events_card.title')}
      titleColor="secondary"
      icon={
        <YnsIcon
          name="webinar"
          className="h-10 w-10 stroke-intoo-green-coachcta"
        />
      }
      actions={
        <LinkButton
          variant="coachcta"
          className="w-full"
          data-action={t('upcoming_events_card.view_action')}
          href="/coach_services/upcoming_events"
        >
          {t('upcoming_events_card.view_action')}
        </LinkButton>
      }
    >
      <div className="flex h-full flex-col items-center justify-center">
        <img
          className="h-45 w-45 "
          src={coachChatImage}
          alt="Live Coach Chat Image"
        />
      </div>
    </Card>
  )
}
